<template>
	<div :class="{'has-error': hasError, 'form-group': label}">
		<label v-if="label" :for="name" class="col-sm-4 col-md-3 control-label">{{{ label }}}</label>

		<div :class="{'col-sm-8 col-md-9': label}">
			<!-- REGULAR INPUTS -->
			<div class="input-group" v-if="!textarea">
				<span v-if="spinner" class="input-group-btn spinner-down">
					<a class="btn btn-default">-</a>
				</span>
				<span v-if="prependIcon" class="input-group-addon"><i class="fa fa-fw fa-{{ prependIcon }}"></i></span>
				<input :type="type" :id="name" :name="name" class="form-control" :placeholder="placeholder" v-model="vmodel">
				<span v-if="postfix" class="input-group-addon">{{{ postfix }}}</span>
				<span v-if="spinner" class="input-group-btn spinner-up">
					<a class="btn btn-default">+</a>
				</span>
			</div>

			<!-- OTHERWISE IF TEXTAREA -->
			<div v-else>
				<textarea :id="name" class="form-control" :rows="rows" :placeholder="placeholder" v-model="vmodel"></textarea>
			</div>

			<!-- ERROR -->
			<span v-if="hasError" class="help-block"><i class="fa fa-exclamation-triangle"></i> {{ errorMessage }}</span>
		</div>
	</div>

</template>

<script>
	import props from './props'
	import events from './events'

	export default {
		props,
		events,

		data() {
			return {
				hasError: false,
				errorMessage: null
			}
		},

		ready() {
			let input = $(`input[name=${this.name}]`);

			if (this.spinner) {
				input.parent().find('.spinner-down > a').on('click', event => {
					event.preventDefault();

					input.val((parseFloat(input.val()) || 0) - 1);

					this.vmodel = input.val();
				});

				input.parent().find('.spinner-up > a').on('click', event => {
					event.preventDefault();

					input.val((parseFloat(input.val()) || 0) + 1);

					this.vmodel = input.val();
				});
			}
		}
	}
</script>

<style scoped>
	.input-group {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// input-text.vue?1a9f85b0